import React from "react";
import { useSelector } from "react-redux";
import StopOutlined from "@ant-design/icons/lib/icons/StopOutlined";
import { ReactComponent as LogoIcon } from "../../../images/logo.svg";
import { checkValue, getHoursMinutesTime } from "../../../constant/helper";
import ClockCircleOutlined from "@ant-design/icons/lib/icons/ClockCircleOutlined";
import { MessageStatus } from "../../../constant/Types";
import AvatarPreview from "../../profile/components/AvatarPreview";
import { Button } from "antd";
import { useHistory } from "react-router-dom";
import MessageDateCategories from "./MessageDateCategories";

const MessageRate = ({
  messagesList,
  index,
  currentlyItem,
  data,
  meta,
  time,
  status,
  openLawyerRate,
  sessionDetail,
}) => {
  const { text } = data;
  // const { id } = meta;
  const { profile } = useSelector((state) => state);

  const history = useHistory();

  return (
    <>
      <MessageDateCategories
        className={{
          textAlign: "center",
          color: "#656567",
          fontWeight: "400",
          fontSize: "14px",
          marginBottom: "1rem",
        }}
        messagesList={messagesList}
        index={index}
        currentlyItem={currentlyItem}
      />
      <div className={"msg msg-client-holder"}>
        <div className="msg-wrapper msg-bot">
          <>
            {text && (
              <div className="msg-text">
                {text}
                <div className="submit-btn">
                  {!checkValue(sessionDetail.rate) && (
                    <Button className={"rate-btn"} onClick={openLawyerRate}>
                      ثبت نظر
                    </Button>
                  )}

                  <Button
                    className={"support-btn"}
                    onClick={() => {
                      history.push("/support");
                    }}
                  >
                    پشتیبانی
                  </Button>
                </div>
              </div>
            )}
            <div className={"msg-avatar-bg"}>
              <div className={"msg-avatar-holder"}>
                <div className={"msg-avatar"}>
                  <AvatarPreview
                    isSvg={false}
                    src={profile.data.extraInfo?.avatarImageUrl || "LAWONE"}
                  />
                </div>
              </div>
            </div>
            <div className={"msg-time"}>
              <div className="msg-sending">
                {status === MessageStatus.sending && <ClockCircleOutlined />}
                {status === MessageStatus.failed && <StopOutlined />}
              </div>

              {time && getHoursMinutesTime(time)}
            </div>
            <div className="msg-bg-holder">
              <span className={"msg-logo-bg"}>
                <LogoIcon />
              </span>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default MessageRate;
